import Vue from 'vue'
import axios from '@/plugins/axios'

export const find = async ({ commit }, filter) => {
  try {
    const { data } = await axios.get('report/services', {
      params: filter,
    })

    if (data?.records) {
      commit('setRows', data.records)

      return data.records
    }

    return null
  } catch (err) {
    return err
  }
}

export const exportServices = async (_, filter = {}) => {
  Vue.prototype.$loading(true)

  try {
    const response = await axios.get('report/services/export', {
      params: filter,
      responseType: 'blob',
    })

    const blob = new Blob([response.data], {
      type: response.headers?.['content-type'] || 'application/octet-stream',
    })

    let fileName = 'relatorio-servicos.xlsx'
    const contentDisposition = response.headers?.['content-disposition']
    if (contentDisposition) {
      const match =
        contentDisposition.match(/filename\*\=UTF-8''([^;]+)/i) ||
        contentDisposition.match(/filename="([^"]+)"/i) ||
        contentDisposition.match(/filename=([^;]+)/i)

      if (match && match[1]) {
        fileName = decodeURIComponent(match[1].trim())
      }
    }

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()

    setTimeout(() => {
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }, 100)

    return true
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const getTariffedQuantityByCampaignId = async (_, campaignId) => {
  try {
    const { data } = await axios.get(`report/services/${campaignId}/tariffed-quantity`)
    return data?.tariffedQuantity ?? null
  } catch (err) {
    return err
  }
}

export const getSmsPhones = async (_, campaignId) => {
  Vue.prototype.$loading(true)

  try {
    const response = await axios.get(`report/sms-phones/${campaignId}`, {
      responseType: 'blob',
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${campaignId}.xlsx`)
    document.body.appendChild(link)
    link.click()

    return true
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const getLinkInfo = async () => {
  Vue.prototype.$loading(true)

  try {
    const response = await axios.get(`report/link-info`)

    return response.data
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const getSmsPhonesAnalytic = async (_, campaignId) => {
  Vue.prototype.$loading(true)

  try {
    const response = await axios.get(`report/sms-phones/analytic/${campaignId}`, {
      responseType: 'blob',
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${campaignId}.xlsx`)
    document.body.appendChild(link)
    link.click()

    return true
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const getSmsPhonesAnalyticVoice = async (_, campaignId) => {
  Vue.prototype.$loading(true)

  try {
    const response = await axios.get(`report/voice-phones/analytic/${campaignId}`, {
      responseType: 'blob',
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${campaignId}.xlsx`)
    document.body.appendChild(link)
    link.click()

    return true
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const getWhatsAppPhones = async (_, campaignId) => {
  Vue.prototype.$loading(true)

  try {
    const response = await axios.get(`report/whatsapp-phones/${campaignId}`, {
      responseType: 'blob',
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${campaignId}.csv`)
    document.body.appendChild(link)
    link.click()

    return true
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}

export const getVoicePhones = async (_, campaignId) => {
  Vue.prototype.$loading(true)

  try {
    const response = await axios.get(`report/voice-phones/${campaignId}`, {
      responseType: 'blob',
    })

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${campaignId}.xlsx`)
    document.body.appendChild(link)
    link.click()

    return true
  } catch (err) {
    return err
  } finally {
    Vue.prototype.$loading(false)
  }
}
export const updateCampaign = async (_, campaign) => {
  try {
    await axios.put(`campaign/${campaign.id}`, campaign)

    return true
  } catch (err) {
    return err
  }
}
export const cancelCampaign = async (_, campaignId) => {
  try {
    await axios.post(`campaign/${campaignId}/cancel`)

    return true
  } catch (err) {
    return err
  }
}

export const getSmsCampaigns = async ({ commit }, filters = {}) => {
  try {
    const { data } = await axios.get('report-graphics/sms-campaigns', {
      params: filters,
    })

    if (data?.campaigns) {
      return data.campaigns
    }

    return []
  } catch (err) {
    console.error('Erro ao buscar campanhas de SMS:', err)
    Vue.prototype.$toast.error('Erro ao carregar campanhas')
    return []
  }
}

export const getOneSmsCampaigns = async ({ commit }, campaignId) => {
  try {
    const response = await axios.get(`report-graphics/sms-campaigns/one/${campaignId}`)
    console.log('campaigns', response)
    if (response.status === 200) {
      return response.data.campaigns
    }

    return []
  } catch (err) {
    console.error('Erro ao buscar campanha de SMS:', err)
    Vue.prototype.$toast.error('Erro ao carregar campanha de SMS')
    return []
  }
}

export const getCampaignWhatsAppPhones = async (_, campaignId) => {
  Vue.prototype.$loading(true)

  try {
    // Usar fetch diretamente para evitar problemas com o interceptor do axios
    const token = localStorage.getItem('token')
    const baseURL = axios.defaults.baseURL || `${process.env.VUE_APP_API_URL}/api/v1`
    const url = `${baseURL}/report/campaign-whatsapp-phones/${campaignId}`
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    // Obter o blob diretamente
    const blob = await response.blob()

    // Verificar se recebeu dados
    if (!blob || blob.size === 0) {
      console.error('Nenhum dado recebido do servidor')
      Vue.prototype.$notify('Erro: Nenhum arquivo recebido', 'error')
      return false
    }

    // Extrair o nome do arquivo do header Content-Disposition
    let fileName = `${campaignId}.xlsx` // fallback
    const contentDisposition = response.headers.get('content-disposition')
    
    if (contentDisposition) {
      // Tentar extrair filename com aspas
      let fileNameMatch = contentDisposition.match(/filename="([^"]+)"/)
      if (!fileNameMatch) {
        // Tentar sem aspas
        fileNameMatch = contentDisposition.match(/filename=([^;]+)/)
      }
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = decodeURIComponent(fileNameMatch[1].trim())
      }
    }

    // Obter o tipo MIME do header Content-Type
    const contentType = response.headers.get('content-type') || 'application/octet-stream'

    console.log('Download arquivo:', {
      fileName,
      contentType,
      size: blob.size,
      type: blob.type
    })

    // Criar URL do blob e fazer download
    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = fileName
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    
    // Limpar após um pequeno delay
    setTimeout(() => {
      document.body.removeChild(link)
      window.URL.revokeObjectURL(blobUrl)
    }, 100)

    Vue.prototype.$notify('Arquivo baixado com sucesso', 'success')
    return true
  } catch (err) {
    console.error('Erro ao baixar arquivo:', err)
    Vue.prototype.$notify('Erro ao baixar arquivo: ' + (err.message || 'Erro desconhecido'), 'error')
    return false
  } finally {
    Vue.prototype.$loading(false)
  }
}
